export default __webpack_public_path__ + "static/media/doctor2.fcc009e9.png";